import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from "./AuthProvider";
import Layout from './Layout'
import Breadcrumbs from './Breadcrumbs';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useFormik } from 'formik';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const locales = [
    {
        locale: 'et',
        label: 'Eesti',
    },
    {
        locale: 'en',
        label: 'English',
    },
];

const Me = ({ me }) => {
    const auth = useAuth();
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const [updating, setUpdating] = useState(false);
    const formik = useFormik({
      initialValues: {
        locale: me.locale,
      },
      onSubmit: values => {
          setUpdating(true);
         let newLocale = values.locale;
         axios.put(`api/users/me/locale/${newLocale}`, null, {
               headers: {
                 Authorization: `Bearer ${auth.token}`,
                 Accept: 'application/json',
               },
             })
           .then(response => {
             sessionStorage.setItem('locale', newLocale);
             i18n.changeLanguage(newLocale);
             navigate(`/settings`);
             setUpdating(false);
           })
           .catch(error => {
               console.log(error);
           });
      },
    });

    return <Form onSubmit={formik.handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>{t('settings.locale')}</Form.Label>
        <Form.Select
          id="locale"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.locale}>
            {locales.map(locale => <option key={locale.locale} value={locale.locale}>{locale.label}</option>)}
        </Form.Select>
      </Form.Group>
        <Button type="submit" variant="primary" disabled={!(formik.isValid && formik.dirty) || updating}>{t('common.save')}</Button>
      </Form>
};

const Settings = () => {
    const auth = useAuth();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [me, setMe] = useState({});
    const { t } = useTranslation();
    const loadMe = useCallback(() => {
        setLoading(true);
        axios.get('/api/users/me', {
            headers: {
                Authorization: `Bearer ${auth.token}`,
            },
        })
        .then(response => {
            setMe(response.data);
            setLoading(false);
        })
        .catch(error => {
            console.log(error);
            setError(error);
            setLoading(false);
            if (error.status === 401) {
                auth.logOut();
            }
        });
    }, [auth]);

    useEffect(() => {
        loadMe();
    }, [loadMe]);

  if (loading) return <p>{t('common.loading')}</p>;
  if (error) return <p>{t('settings.loading-error')}: {error.message}</p>;

  return (
      <Layout>
        <Breadcrumbs />
        {loading && <div>{t('common.loading')}</div>}
        {!loading && <Me me={me} />}
      </Layout>
    );
};

export default Settings;